<template>
  <div id="app">
    <Header />
    <main class="main-content">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'

export default {
  name: "App",
  components: {
    Header,
    Footer
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/*
:root {
  /* единый источник правды для затемнения — редактируйте это значение чтобы изменить интенсивность
  --overlay-bg: rgba(0, 0, 0, 0.5); /* <- при необходимости поставьте 0.8 или 0.6
}
*/

body {
  font-family: 'Raleway', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

body.modal-open {
  /* гарантия, что overlay сработает */
  position: relative;
}

body.modal-open::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: 10000;             /* overlay под модалкой (modal z-index = 10050 в компоненте) */
  background: rgba(0,0,0,0.48);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  pointer-events: auto;
}
</style>
